const AQUEDUCT_EARLY_ACCESS_FORM_URL = 'https://iliadai.typeform.com/to/ytIRCUB4';

export function aqueductEarlyAccessFormUrl(email: string): string {
	return `${AQUEDUCT_EARLY_ACCESS_FORM_URL}#email=${encodeURIComponent(email)}`;
}
